// extracted by mini-css-extract-plugin
export default {"container":"AdminStockManagement_container__tSPkZ","placeholder":"AdminStockManagement_placeholder__LVm4u"};